/**
 * Нягтлан бодогч — `/accounting` (2026-10-15). Нягтлан бодогчийн 5 шаардлага
 * нэг хуудсанд, таб бүр нэг асуултад хариулна:
 *   Борлуулалт       өдөр бүр салбар × нийлүүлэгчээр (буцаалт буцсан өдөртөө)
 *   Үнийн өөрчлөлт   зарах үнэ өдөр/сар/оноор, салбараар
 *   Нийлүүлэгч       өглөг, авлага, гүйлгээний дэвтэр (₽)
 *   Ханш             төлбөр бүрийн ханшийн олз/гарз (цуглуулагчийн ханшаар)
 *   Үлдэгдэл         размер × салбар: ширхэг, зарах үнэ, өртөг
 *
 * Таб нь URL-д (`?tab=`) — холбоосоор хуваалцаж, хуудас сэргээхэд хадгалагдана.
 * Бүх таб ЗӨВХӨН УНШИНА; төлбөр бүртгэх нь «Зээл, төлөлт» (`/credit`).
 */

import { useSearchParams } from 'react-router-dom';
import { useAuth } from '../lib/auth';
import { ErrorNote, Tabs } from '../components/ui';
import { SalesDailyTab } from '../components/accounting/sales-daily';
import { PriceChangesTab } from '../components/accounting/price-changes';
import { SuppliersTab } from '../components/accounting/suppliers';
import { FxTab } from '../components/accounting/fx';
import { StockBySizeTab } from '../components/accounting/stock-by-size';

const TABS = [
  { key: 'sales', label: 'Борлуулалт' },
  { key: 'prices', label: 'Үнийн өөрчлөлт' },
  { key: 'suppliers', label: 'Нийлүүлэгчийн тооцоо' },
  { key: 'fx', label: 'Ханшийн тэгшитгэл' },
  { key: 'stock', label: 'Үлдэгдэл размераар' },
] as const;

type Tab = (typeof TABS)[number]['key'];

export function AccountingPage() {
  const { hasPerm } = useAuth();
  const [params, setParams] = useSearchParams();
  const raw = params.get('tab');
  const tab: Tab = TABS.some((t) => t.key === raw) ? (raw as Tab) : 'sales';

  if (!hasPerm('accounting.view')) return <ErrorNote>Нягтлангийн тайлан харах эрх танд байхгүй.</ErrorNote>;

  // Таб солиход шүүлт (огноо, салбар) хэвээр — нягтлан нэг хугацааг олон талаас харна
  const select = (key: Tab) => {
    const next = new URLSearchParams(params);
    next.set('tab', key);
    setParams(next, { replace: true });
  };

  return (
    <div className="flex flex-col gap-3.5">
      <Tabs tabs={[...TABS]} value={tab} onChange={select} scroll />
      {tab === 'sales' ? <SalesDailyTab /> : null}
      {tab === 'prices' ? <PriceChangesTab /> : null}
      {tab === 'suppliers' ? <SuppliersTab /> : null}
      {tab === 'fx' ? <FxTab /> : null}
      {tab === 'stock' ? <StockBySizeTab /> : null}
    </div>
  );
}
